// components/Footer/Footer.jsx
import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div style={{ width: '100%', color: 'white' }}>
      {/* Top row with logo and links */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 40px',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        {/* Logo placeholder - replace with actual logo */}
        <div style={{ fontSize: '24px', fontWeight: 'bold', color: 'white' }}>
          August Twenty
        </div>

        {/* Links on the right */}
        <ul style={{
          display: 'flex',
          gap: '30px',
          listStyle: 'none',
          margin: 0,
          padding: 0,
          flexWrap: 'wrap'
        }}>
          {/* <li>
            <a 
              href="/privacy-policy" 
              style={{ color: 'white', textDecoration: 'none', transition: 'opacity 0.2s' }}
              onMouseOver={(e) => e.target.style.opacity = '0.8'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              Privacy Policy
            </a>
          </li> */}
          <li>
            <a 
              href="/terms-and-conditions" 
              style={{ color: 'white', textDecoration: 'none', transition: 'opacity 0.2s' }}
              onMouseOver={(e) => e.target.style.opacity = '0.8'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              Terms & Conditions
            </a>
          </li>
        </ul>
      </div>

      {/* Separator line */}
      <div style={{
        height: '1px',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        width: '100%',
        margin: '10px 0'
      }} />

      {/* Bottom row with copyright */}
      <div style={{
        padding: '20px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <span style={{ color: 'white' }}>
          © 2026 August Twenty. All rights reserved.{' '}
          <a
            href="https://draftpoint.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', textDecoration: 'none', transition: 'opacity 0.2s' }}
            onMouseOver={(e) => (e.target.style.opacity = '0.8')}
            onMouseOut={(e) => (e.target.style.opacity = '1')}
          >
            Website by Draftpoint
          </a>
        </span>
      </div>
    </div>
  );
};

export default Footer;